__webpack_require__.p = "/dev/doc-sources/";